module.exports = __webpack_public_path__ + "static/media/NUS.e08be1ac.jpg";